(function () {
  if (window.__pwBridgeRevealInit) {
    if (typeof window.__pwBridgeRevealScan === 'function') {
      window.__pwBridgeRevealScan();
    }
    return;
  }
  window.__pwBridgeRevealInit = true;

  var supportsObserver = typeof IntersectionObserver !== 'undefined';

  if (!supportsObserver) {
    var fallback = function () {
      document.querySelectorAll('.pw-reveal').forEach(function (el) {
        el.classList.add('is-visible');
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fallback);
    } else {
      fallback();
    }
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.05
  });

  var scan = function () {
    document.querySelectorAll('.pw-reveal:not(.is-visible)').forEach(function (el) {
      observer.observe(el);
    });
  };

  window.__pwBridgeRevealScan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
